import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import cloudinary from "cloudinary/lib/cloudinary";

import "./App.css";

const Register = lazy(() => import("./pages/register"));
const Home = lazy(() => import("./pages/home"));
const UploadReceiptPage = lazy(() => import("./pages/UploadReceiptPage"));
const Upload_meetandgreet = lazy(() => import("./pages/Upload_meetandgreet"));
const RedeemRewards = lazy(() => import("./pages/redeem_rewards"));
const RegisterPets = lazy(() => import("./pages/register_pets"));
const AddAddress = lazy(() => import("./pages/add_address"));
const EditProfile = lazy(() => import("./pages/edit_profile"));
const Profile = lazy(() => import("./pages/profile"));
const Edit_address = lazy(() => import("./pages/edit_address"));
const EditPets = lazy(() => import("./pages/EditPets"));
const SuccessRegisterPage = lazy(() => import("./pages/SuccessRegisterPage"));
const AlertSuscess = lazy(() => import("./pages/alertSuscess"));
const Add_addressRedeem = lazy(() => import("./pages/add_addressRedeem"));
const UserRoute = lazy(() => import("./components/routes/UserRoute"));
const Delivery = lazy(() => import("./pages/delivery"));
const PetShop = lazy(() => import("./pages/petShop"));
const Login = lazy(() => import("./pages/Login"));
const LineLoginProd = lazy(() => import("./pages/LineLoginProd"));
const LuckyDraw = lazy(() => import("./pages/lucky_draw"));
const LuckyDrawDetail = lazy(() => import("./pages/lucky_draw_detail"));
const LuckyDrawExchange = lazy(() => import("./pages/lucky_draw_exchange"));
const SelectCampaign = lazy(() => import("./pages/select_campaign"));
const goldCampaign = lazy(() => import("./pages/goldCampaign"));
const normalCampaign = lazy(() => import("./pages/ButterBearNormalCampaign"));
const uploadGoldCampaign = lazy(() => import("./pages/upload-gold-campaign"));
const uploadNormalCampaign = lazy(() => import("./pages/upload-normal-campaign"));

cloudinary.config({
  cloud_name: process.env.REACT_APP_CLOUD_NAME,
  api_key: process.env.REACT_APP_API_KEY,
  api_secret: process.env.REACT_APP_API_SECRET,
});

const App = () => {
  // Prodution  /////////
  // const liffId = "1660688630-NeqEEQ62";
  // const liffId2 = "2003848518-pYEnWv62";
  // const liffIdProd = "2004859316-2pyBv7Y8";
  //------------------//

  // ------------UAT Meet&Greet ------------- //
  // const liffId = "1661110329-vPxWabm6";
  // const liffId2 = "2006383440-LQAjPBb4";
  // const liffIdProd = "2006383449-yQVd7GZN";

  return (
    <div className="App">
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Switch>
            <Route exact path="/" component={LineLoginProd} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/select_campaign" component={SelectCampaign} />
            <Route exact path="/register" component={Register} />
            <Route
              exact
              path="/successRegister"
              component={SuccessRegisterPage}
            />

            <UserRoute exact path="/home" component={Home} />
            <UserRoute
              exact
              path="/Upload_meetandgreet"
              component={Upload_meetandgreet}
            />
            <UserRoute exact path="/redeem_rewards" component={RedeemRewards} />
            <UserRoute exact path="/register_pets" component={RegisterPets} />
            <UserRoute exact path="/add_address" component={AddAddress} />
            <UserRoute exact path="/delivery/:id/:point" component={Delivery} />
            <UserRoute exact path="/edit_profile" component={EditProfile} />
            <UserRoute exact path="/profile" component={Profile} />
            <UserRoute
              exact
              path="/edit_address/:id"
              component={Edit_address}
            />
            <UserRoute exact path="/EditPets/:id" component={EditPets} />
            <UserRoute
              exact
              path="/alertSuscess/:page"
              component={AlertSuscess}
            />
            <UserRoute
              exact
              path="/add_addressRedeem"
              component={Add_addressRedeem}
            />
            <UserRoute exact path="/petShop" component={PetShop} />
            <UserRoute exact path="/lucky-draw" component={LuckyDraw} />
            <UserRoute
              exact
              path="/lucky-draw-detail"
              component={LuckyDrawDetail}
            />
            <UserRoute
              exact
              path="/lucky-draw-exchange"
              component={LuckyDrawExchange}
            />
            <UserRoute
              exact
              path="/upload-receipt"
              component={UploadReceiptPage}
            />
            <UserRoute
              exact
              path="/goldCampaign"
              component={goldCampaign}
            />
            <UserRoute
              exact
              path="/ButterBearNormalCampaign"
              component={normalCampaign}
            />
            <UserRoute
              exact
              path="/upload-gold-campaign"
              component={uploadGoldCampaign}
            />
            <UserRoute
              exact
              path="/upload-normal-campaign"
              component={uploadNormalCampaign}
            />
          </Switch>
        </Suspense>
      </Router>
    </div>
  );
};

export default App;
